export default {
  showSidebar: false
}
